import { getDateNumber } from '@shared/utils';
import { useTimeZone, useTranslations } from 'next-intl';

function useMagazinePublishedDate(publishedDate: string) {
  const t = useTranslations('magazine');
  const timeZone = useTimeZone();
  const date = new Date(publishedDate);

  return t('published_date', { date, day: getDateNumber(date, timeZone) });
}

export { useMagazinePublishedDate };
